<template>
  <div class="flex flex-col justify-center h-full leading-tight">
    <span class="sensitive text-sm text-gray-900 truncate">{{ titleCase(primary) || '-' }}</span>
    <span v-if="secondary" class="sensitive text-xs text-gray-500 truncate">{{ titleCase(secondary) }}</span>
  </div>
</template>

<script>
export default {
  name: 'Quality_EntityCell',
  props: ['params'],
  computed: {
    primary() {
      return this.params.data?.practice_name;
    },
    secondary() {
      return this.params.data?.provider_name;
    }
  },
  methods: {
    titleCase(str) {
      if (!str) return str;
      const keep = new Set(['LLC', 'PLLC', 'PC', 'MD', 'DO', 'NP', 'PA', 'RN', 'DPM', 'OD', 'II', 'III', 'IV']);
      return str.split(/\s+/).map(w => {
        const clean = w.replace(/[,.]$/, '');
        if (keep.has(clean.toUpperCase())) return w.toUpperCase();
        return w.toLowerCase().replace(/^\w/, c => c.toUpperCase());
      }).join(' ');
    }
  }
};
</script>
